/*
 * @version: 1.0
 * @Date: 2021-08-31 16:17:16
 *
 * @LastEditTime: 2023-08-10 10:13:57
 * @FilePath: \accurate_sugar_control\src\api\axios.js
 */
//ajax 请求
import axios from "axios";
import { Toast } from "mint-ui";
import Qs from "qs";
import { Loading } from "element-ui";
import { Message } from "element-ui";

// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8';
const service = axios.create({
  baseURL: "https://mapi.yicheng120.com/yinchuan_home", //线上正式库 银川
  //  baseURL: "https://test.yicheng120.com:981/accurate_sugar_control_yc_api", //测试环境 银川
  //  baseURL: "http://192.168.248.128:8080/accurate_sugar_control_yc_api", //测试环境 银川
  // baseURL: "/api",

  timeout: 100000,
  // transformRequest: [function (data) {//请求预处理函数
  //   return Qs.stringify(data)
  // }],
  transformRequest: [
    function(data) {
      if (!data) {
        return;
      }
      //请求预处理函数
      if (data.graphicUpload != 1) {
        return Qs.stringify(data);
      } else {
        let formData = new FormData();
        if (data.file) {
          Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
          });
        }
        return formData;
      }
    }
  ]
  // withCredentials: true,    //跨域
});
//对数组的方法进行重写
const ajaxMethod = ["get", "post"];
const api = {};
let that = this;

ajaxMethod.forEach(method => {
  api[method] = function(url, data) {
    return new Promise(function(resolve, reject) {
      service[method](url, data).then(response => {
        // console.log(response);
        resolve(response.data);
      });
      // .catch(function (error) {
      //   Toast(error)
      // })
    });
  };
});

export default api;



// WEBPACK FOOTER //
// ./src/api/axios.js